import { TextModules } from "interfaces/textView";
import { getCustomerCode } from "app/utils";
import TextView from "components/features/TextView/TextView";

const Loader = () => {
  const customerCode = getCustomerCode();
  const mainClass =
    customerCode === "lhs"
      ? "modal-backdrop fade in"
      : customerCode === "oss" || customerCode === "sns"
        ? "modal-backdrop fade in modal-backdrop-loader"
        : "modal-backdrop fade in";

  return (
    <div
      className={`modal-loader ${mainClass}`}
    >
      {customerCode === "lhs" ? (
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header modal-header-loader text-center">
              <h1>
                <TextView textId={"loading"} module={TextModules.GENERAL} />
              </h1>
            </div>
            <div id="lh-loading">
              <div id="lh-loading_1" className="lh-loading"></div>
              <div id="lh-loading_2" className="lh-loading"></div>
              <div id="lh-loading_3" className="lh-loading"></div>
              <div id="lh-loading_4" className="lh-loading"></div>
              <div id="lh-loading_5" className="lh-loading"></div>
              <div id="lh-loading_6" className="lh-loading"></div>
              <div id="lh-loading_7" className="lh-loading"></div>
              <div id="lh-loading_8" className="lh-loading"></div>
              <div id="lh-loading_9" className="lh-loading"></div>
            </div>
          </div>
        </div>
      ) : customerCode === "oss" || customerCode === "sns" ? (
        <>
          <h1 className="loading-text">
            <TextView textId={"loading"} module={TextModules.GENERAL} />
          </h1>
          <div id="lh-loading">
            <div id="lh-loading_1" className="lh-loading"></div>
            <div id="lh-loading_2" className="lh-loading"></div>
            <div id="lh-loading_3" className="lh-loading"></div>
            <div id="lh-loading_4" className="lh-loading"></div>
            <div id="lh-loading_5" className="lh-loading"></div>
            <div id="lh-loading_6" className="lh-loading"></div>
            <div id="lh-loading_7" className="lh-loading"></div>
            <div id="lh-loading_8" className="lh-loading"></div>
            <div id="lh-loading_9" className="lh-loading"></div>
          </div>
        </>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default Loader;
